// ============================================================
// Helpers — flags exposés par GET /health.
// ============================================================
// On ne fetch /health qu'une fois (cache module). Suffisant
// pour l'usage actuel : décider si on affiche le bouton
// "Export PDF serveur" qui requiert Browser Rendering.
// ============================================================

import { api } from './api';

type HealthResponse = {
  ok: boolean;
  pdf_server_enabled?: boolean;
};

let cached: Promise<HealthResponse> | null = null;

function fetchHealth(): Promise<HealthResponse> {
  if (!cached) {
    cached = api.get<HealthResponse>('/health').catch(() => ({ ok: false }));
  }
  return cached;
}

export async function isPdfServerEnabled(): Promise<boolean> {
  const h = await fetchHealth();
  return !!h.pdf_server_enabled;
}
